<script lang="ts">
import { useFilterStub } from './filter-stub';
import { LocalFilterModel } from './FilterSelect.vue';
</script>

<script setup lang="ts" generic="T">
defineExpose(
  useFilterStub<T, LocalFilterModel<T>>(
    {
      filter: null,
      type: 'equals',
    },
    ({ filter }) => filter !== null,
    ({ filter }, value) => filter === value
  )
);
</script>

<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>
